let routes = [
  // 授权页面
  {
    path: '/wxAuth',
    name: 'auth',
    component: () => import('@/views/Auth.vue')
  },
  // 微信小程序授权页面
  {
    path: '/wx-mini-auth',
    name: 'wx-mini-auth',
    component: () => import('@/views/WxMiniAuth.vue')
  },
  // 申请表单
  {
    path: '/apply/:id',
    name: 'apply',
    component: () => import('@/views/Apply.vue')
  },
  // 申请记录
  {
    path: '/record/:id',
    name: 'record',
    component: () => import('@/views/Record.vue')
  },
  // 申请记录详情
  {
    path: '/recordDetail/:recordId/:id',
    name: 'recordDetail',
    component: () => import('@/views/RecordDetail.vue')
  },
  // 表单预览
  {
    path: '/preview/:id',
    name: 'preview',
    component: () => import('@/views/Preview.vue')
  },
  // 提交成功页面
  {
    path: '/result',
    name: 'result',
    component: () => import('@/views/Result.vue')
  },
  // 表单首页
  {
    path: '/:id',
    name: 'index',
    component: () => import('@/views/Index.vue')
  }
]

routes = [...routes]

export default routes
